<template>
  <div class="consultingServicePage">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo" class="hidden-xs"></v-publicBanner>
    <v-recruitmentBanner :bannerInfo="bannerInfoMobile" class="hidden-sm hidden-md hidden-lg"></v-recruitmentBanner>
    <div class="strategicAgreement">
      <v-publiceTit :titleObj="titleObj"></v-publiceTit>
      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item name="1">
          <template slot="title">
            <span class="orderNumber">01</span><span class="question">问：哪些企业可以使用这项服务呢？</span>
          </template>
          <div>复星集团各成员企业均可申请使用，尤其是新加入、新成立的中小型企业；</div>
          <div>尚未设置独立成本采购部的成员企业。</div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <span class="orderNumber">02</span><span class="question">问：一链采购咨询涵盖哪些服务范围？</span>
          </template>
          <div>针对用户企业的需求，一链采购咨询团队可提供战略采购咨询（如采购政策管理、采购战略开发）、采购运营管理（如集采协议支持、采购运作服务）</div>
          <div><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/strategicAgreement01.jpg" alt=""></div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <span class="orderNumber">03</span><span class="question">问：服务形式是怎样的？</span>
          </template>
          <div>为了让更多复星成员企业获得服务支持，一链采购咨询服务会优先提供远程服务，如钉钉在线咨询、邮件、电话咨询，同时针对特定的企业用户需求，一链也会安排现场派驻、支持服务。</div>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <span class="orderNumber">04</span><span class="question">问：服务是怎么收费的？</span>
          </template>
          <div>现阶段对于复星系核心企业免费服务；可提供客户定制的共享采购服务。</div>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template slot="title">
            <span class="orderNumber">05</span><span class="question">问：怎么获取这项服务呢？</span>
          </template>
          <div>获取服务的流程如下</div>
          <div><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/strategicAgreement02.jpg" alt=""></div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="consultationHotline">
      <div class="hotlineCon row">
        <div class="hotlineConLeft col-xs-12 col-sm-8 col-md-8 col-lg-8">
          <h4>采购咨询</h4>
          <p>客服热线：400-108-6116</p>
          <p>服务邮箱：epfosunhelp@fosun.com</p>
        </div>
        <div class="hotlineConRight col-xs-12 col-sm-4 col-md-4 col-lg-4">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/consultationHotline.png" alt="">
        </div>
      </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import recruitmentBanner from '@/components/recruitmentBanner'
  import publiceTit from '@/components/publiceTit'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        var isMob=  /^0\d{2,3}-?\d{7,8}$/;// 座机格式
        if (!reg.test(value)&&!isMob.test(value)) {
          return callback(new Error('请输入有效的联系电话'));
        }else{
          return callback();
        }
      };
      return {
        options: [{
          value: '0',
          label: '采购商'
        }, {
          value: '1',
          label: '供应商'
        }],
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        navigationColumnInfos: [],
        bannerInfo: {title: '采购咨询服务',content: "为了更好地服务复星集团各成员企业的采购管理需求，践行一链网作为采购解决方案服务商的战略定位，一链网面向复星集团各成员企业推出采购咨询服务。"},
        bannerInfoMobile: {name: '采购咨询服务', eng: 'Consulting Services'},
        titleObj: {name: '常见问题', eng: 'Strategic agreement'},
        webConfigInfo: {},
        footerColumnInfos:[],
        messageData: [],
        messageTotal:0,
        currentPage:1,
        centerDialogVisible:false,
        selectTrialPlatform:'',
        checkList:[],
        activeNames:'1'
        
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-recruitmentBanner': recruitmentBanner,
      'v-publiceTit': publiceTit,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
      this.webConfigInfo = this.data.webConfigInfoDto;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
    }).catch((err) => {
        console.log(err)
    })
    },
    mounted () {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/consultingService/index.vue